import gui from '@/webgl/dev/gui'
import FPSLimiter from '@/webgl/FPSLimiter'
import GameWorld from '@/webgl/runner/GameWorld'

export default class GameTime {
  private readonly world: GameWorld

  stopTime: number = 0
  limiter: FPSLimiter

  constructor(world: GameWorld) {
    this.world = world

    this.limiter = new FPSLimiter()
    this.limiter.enabled = false
    this.limiter.fps = 60

    /// #if _DEBUG
    const fld = gui.folder('Time System')
    fld.add(this.limiter, 'fps', { min: 0, max: 120 })
    fld.add(this.limiter, 'enabled')
    /// #endif
  }

  public update(deltaTime: number) {
    this.limiter.step(deltaTime)
    this.world.time.time += this.limiter.dt
    this.world.time.deltaTime = this.limiter.dt

    this.world.time.unscaledTime += deltaTime
    this.world.time.unscaledDeltaTime = deltaTime
  }
}
